import React, { useContext } from 'react';
import MenuItem from '@mui/material/MenuItem';
import DeleteIcon from '@mui/icons-material/Delete';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MuiDialog from '../../SystemDesign/MuiDialog';
import { useDispatch } from 'react-redux';
import { useDeleteUserMutation } from '../../services/SkillsManagement';
import { DELETE_USER_COMPANY, DELETE_EMPLOYEE } from '../../Reducers/Actions';
import { SnackBarContext } from '../../Context/SnackBarContextProvider';

const DeleteUserCompany = ({ row, actionKey }) => {
  const user = row.original;
  const dispatch = useDispatch();
  const [deleteUser] = useDeleteUserMutation();
  const { setInfoAlert, setOpenSnackBar } = useContext(SnackBarContext);

  const handleDelete = async () => {
    try {
      await deleteUser({
        userId: user.id,
        ...(actionKey === 'delete-archived' && { force: true }),
        type: 'user'
      }).unwrap();
      
      dispatch({ type: DELETE_USER_COMPANY, userId: user.id });
      // Also update employees slice used by UserCompanyList
      dispatch({ type: DELETE_EMPLOYEE, userId: user.id });
      setInfoAlert({ 
        severity: 'success', 
        message: `User ${user.username} has been deleted successfully` 
      });
      setOpenSnackBar(true);
      return true;
    } catch (error) {
      setInfoAlert({ 
        severity: 'error', 
        message: `Error deleting user ${user.username}` 
      });
      setOpenSnackBar(true);
      return false;
    }
  };

  const triggerButton = (
    <MenuItem>
      <ListItemIcon>
        <DeleteIcon fontSize="small" />
      </ListItemIcon>
      <ListItemText>{actionKey === 'delete-archived' ? 'Delete permanently' : 'Delete'}</ListItemText>
    </MenuItem>
  );

  const dialogContent = (
    <div>
      <p>Are you sure you want to {actionKey === 'delete-archived' ? 'delete permanently' : 'delete'} this user?</p>
      <p>{actionKey === 'delete-archived' ? 'This action is definitive and irreversible.' : 'This action is irreversible.'}</p>
    </div>
  );

  return (
    <MuiDialog
      icon={<DeleteIcon />}
      triggerButton={triggerButton}
      title={actionKey === 'delete-archived' ? "Delete permanently" : "Delete"}
      subtitle={`You are about to ${actionKey === 'delete-archived' ? 'delete permanently' : 'delete'} ${user.username || "user"}`}
      content={dialogContent}
      existAction={true}
      actionTitle={actionKey === 'delete-archived' ? "Delete permanently" : "Delete"}
      actionFunction={handleDelete}
      actionType="button"
    />
  );
};

export default DeleteUserCompany;
